import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import IncidentScatterPlot from '../Charts/IncidentScatterPlot'; // Scatter plot component
import IncidentPieChart from '../Charts/IncidentPieChartByType'; // Pie chart component
import { getIncidents, getTrafficCameras, getCrashData } from '../../api/api';

const Dashboard = () => {
  const [latestIncidents, setLatestIncidents] = useState([]);
  const [topAssets, setTopAssets] = useState([]);
  const [latestAccidents, setLatestAccidents] = useState([]);
  const [incidentChartData, setIncidentChartData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const [incidents, trafficCameras, crashData] = await Promise.all([
        getIncidents({ limit: 5 }),
        getTrafficCameras({ limit: 5 }),
        getCrashData({ limit: 5 }),
      ]);

      setLatestIncidents(incidents.data.data.map(item => ({
        id: item._id,
        time: item.createdAt,
        source: item.sourceType,
        workflow: item.workflowId.name,
        event: item.eventId.type,
      })));

 

      setLatestAccidents(crashData.data.records.map(item => ({
        id: item['_id'],
        crashId: item['Crash ID'],
        time: item.timestamp,
        address: item['Primary address'],
      })));

      const chartData = await getIncidents({limit : 100});
      setIncidentChartData(chartData.data.data.map(item => ({
        date: new Date(item.createdAt).toISOString().split('T')[0],
        time: new Date(item.createdAt).toISOString().split('T')[1].slice(0, 5),
        type: item.eventId.type,
      })));
    };

    fetchData();
  }, []);

  return (
    <Grid container spacing={3} style={{ padding: '20px' }}>

      {/* Incident Chart */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Incident Scatter Plot (Last 24 Hours)</Typography>
            <IncidentScatterPlot data={incidentChartData} />
          </CardContent>
        </Card>
      </Grid>

      {/* Incident Pie Chart */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Incident Distribution by Type</Typography>
            <IncidentPieChart data={incidentChartData} />
          </CardContent>
        </Card>
      </Grid>
      {/* Latest 5 Incidents */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Latest 5 Incidents</Typography>
            <Grid container spacing={2}>
              {latestIncidents.map((incident, index) => (
                <Grid item xs={6} key={index}>
                  <Card>
                    <CardContent>
                      <Typography variant="body2">{`Time: ${new Date(incident.time).toLocaleString()}`}</Typography>
                      <Typography variant="body2">{`Source: ${incident.source}`}</Typography>
                      <Typography variant="body2">{`Workflow: ${incident.workflow}`}</Typography>
                      <Typography variant="body2">{`Event: ${incident.event}`}</Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate(`/incident/${incident.id}`)}
                      >
                        View Details
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>

     

      {/* Latest Accidents */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Latest Accidents (Last 24 Hours)</Typography>
            <Grid container spacing={2}>
              {latestAccidents.map((accident, index) => (
                <Grid item xs={6} key={index}>
                  <Card>
                    <CardContent>
                      <Typography variant="subtitle1">{`Accident ID: ${accident.crashId}`}</Typography>
                      <Typography variant="subtitle1">{`Address: ${accident.address}`}</Typography>
                      <Typography variant="body2">{`Time: ${new Date(accident.time).toLocaleString()}`}</Typography>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => navigate(`/crash-data/${accident.id}`)}
                      >
                        View Details
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      
    </Grid>
  );
};

export default Dashboard;
